
export class ReimbursementRequest {

    public firstName: string = "";
    public lastName: string = "";
    public contractNumber: string = "";
    public reimbursementType: string = ""

    public addressLine1: string = "";
    public addressLine2: string = "";
    public city: string = "";
    public state: string = "";
    public zip: string = "";
    public phoneNumber: string = "";

}